/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["a[_ngcontent-%COMP%]{background-color:#25d366;z-index:9999999;position:fixed;width:65px;height:65px;bottom:30px;left:25px;color:#fff;border-radius:50px;text-align:center}i[_ngcontent-%COMP%]{font-size:55px;margin-top:5px}\n/*# sourceMappingURL=widget.component.css.map*/"];
export { styles as styles };
